"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
var _customPage = require("@/api/customPage");
var _sortablejs = _interopRequireDefault(require("sortablejs"));
var _pageConfigPop = _interopRequireDefault(require("./components/pageConfigPop.vue"));
var _bannerListPop = _interopRequireDefault(require("../components/bannerListPop.vue"));
var _addModule = _interopRequireDefault(require("../components/addModule.vue"));
var _banner = _interopRequireDefault(require("../components/banner.vue"));
var _diamond = _interopRequireDefault(require("../components/diamond.vue"));
var _freePuzzle = _interopRequireDefault(require("../components/freePuzzle.vue"));
var _marqueePop = _interopRequireDefault(require("./components/marqueePop.vue"));
var _floatingWindowPop = _interopRequireDefault(require("./components/floatingWindowPop.vue"));
var _earningsReportPop = _interopRequireDefault(require("./components/earningsReportPop.vue"));
var _collectionPop = _interopRequireDefault(require("./components/collectionPop.vue"));
var _hotPicksPop = _interopRequireDefault(require("./components/hotPicksPop.vue"));
var _topSearch = _interopRequireDefault(require("../components/topSearch.vue"));
var _bannerWithPuzzle = _interopRequireDefault(require("../components/bannerWithPuzzle.vue"));
var _verticalBannerWithPuzzle = _interopRequireDefault(require("../components/verticalBannerWithPuzzle.vue"));
var _slidingCapsule = _interopRequireDefault(require("../components/slidingCapsule"));
var _earningsReport = _interopRequireDefault(require("../components/earningsReport.vue"));
var _diamondWithTypePop = _interopRequireDefault(require("./components/diamondWithTypePop.vue"));
var _hotPicks = _interopRequireDefault(require("../components/hotPicks.vue"));
var _floatingWindow = _interopRequireDefault(require("../components/floatingWindow.vue"));
var _bottomShopList = _interopRequireDefault(require("../components/bottomShopList.vue"));
var _marquee = _interopRequireDefault(require("../components/marquee.vue"));
var _collection = _interopRequireDefault(require("../components/collection.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    floatingWindowPop: _floatingWindowPop.default,
    earningsReport: _earningsReport.default,
    pageConfigPop: _pageConfigPop.default,
    bannerListPop: _bannerListPop.default,
    addModule: _addModule.default,
    banner: _banner.default,
    diamond: _diamond.default,
    freePuzzle: _freePuzzle.default,
    marqueePop: _marqueePop.default,
    earningsReportPop: _earningsReportPop.default,
    collectionPop: _collectionPop.default,
    hotPicksPop: _hotPicksPop.default,
    topSearch: _topSearch.default,
    bannerWithPuzzle: _bannerWithPuzzle.default,
    verticalBannerWithPuzzle: _verticalBannerWithPuzzle.default,
    slidingCapsule: _slidingCapsule.default,
    diamondWithTypePop: _diamondWithTypePop.default,
    hotPicks: _hotPicks.default,
    floatingWindow: _floatingWindow.default,
    bottomShopList: _bottomShopList.default,
    marquee: _marquee.default,
    collection: _collection.default
  },
  props: {},
  data: function data() {
    return {
      loading: false,
      pageId: '',
      backgroundConfig: {},
      tableData: [],
      pageName: ''
    };
  },
  computed: {},
  created: function created() {
    this.pageName = this.$route.query.activityName;
    this.pageId = this.$route.query.id;
    this.findModule();
  },
  mounted: function mounted() {
    this.drageBuff();
    // this.$refs.hotPicksPop.open()
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: '/appNewRenovation/home/index'
      });
    },
    refreshModule: function refreshModule(val) {
      console.log('刷新模块-------------------', val);
      this.tableData.map(function (i) {
        if (i.moduleId === val) {
          i.timestamp = new Date().getTime();
        }
      });
    },
    moduleUpdate: function moduleUpdate(val) {
      console.log(val, '===============');
      if (val.componentCode === 'richText') {
        this.$refs.richPop.open({
          name: val.name,
          id: val.moduleId
        });
      } else if (val.componentCode === 'shopList') {
        this.$refs.shopListSetting.open({
          id: val.moduleId
        });
      } else if (val.componentCode === 'earningsReport') {
        this.$refs.earningsReportPop.open({
          id: val.moduleId
        });
      } else if (val.componentCode === 'hotPicks') {
        this.$refs.hotPicksPop.open({
          id: val.moduleId
        });
      } else if (val.componentCode === 'marquee') {
        this.$refs.marqueePop.open({
          id: val.moduleId
        });
      } else if (val.componentCode === 'collection') {
        this.$refs.collectionPop.open({
          id: val.moduleId
        });
      } else if (val.componentCode === 'floatingWindow') {
        this.$refs.floatingWindowPop.open({
          id: val.moduleId
        });
      } else if (val.componentCode === 'diamond' && val.componentSubcode === 's_a_c') {
        this.$refs.diamondWithTypePop.open({
          id: val.moduleId,
          name: val.name + '（' + val.remark + '）',
          componentSubcode: val.componentSubcode,
          componentCode: val.componentCode
        });
      } else {
        this.$refs.bannerListPop.open({
          name: val.remark ? "".concat(val.name, "\uFF08  ").concat(val.remark, "  \uFF09") : val.name,
          id: val.moduleId,
          componentSubcode: val.componentSubcode,
          componentCode: val.componentCode
        });
      }
    },
    addModule: function addModule() {
      this.$refs.addModule.open({
        // type: 'add',
        // title: ''
      });
    },
    del: function del(val) {
      var _this = this;
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deleteSort)({
          moduleId: val.moduleId
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this.findModule();
        });
      });
    },
    allChange: function allChange(val, text) {
      var _this2 = this;
      var obj = {
        moduleId: val.moduleId
      };
      obj[text] = val[text];
      console.log(obj);
      this.$confirm('是否确认编辑?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.updateStatus)(obj).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this2.findModule();
        });
      }).catch(function () {
        if (val[text] === 1) {
          val[text] = 0;
        } else {
          val[text] = 1;
        }
      });
    },
    saveBgColor: function saveBgColor() {
      this.$refs.pageConfigPop.open(this.backgroundConfig);
    },
    findModule: function findModule() {
      var _this3 = this;
      this.loading = true;
      (0, _customPage.getModuleList)({
        pageId: this.pageId
      }).then(function (res) {
        _this3.loading = false;
        _this3.backgroundConfig = res.data.backgroundConfig;
        // this.tableData = []
        res.data.pageModuleList.map(function (i) {
          i['boole'] = false;
          i['timestamp'] = new Date().getTime();
          if (i.remark == null) {
            i.remark = '';
          }
        });
        _this3.tableData = res.data.pageModuleList;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    bothMouseOver: function bothMouseOver(val, itemIndex) {
      if (val.componentCode === 'floatingWindow' || val.componentCode === 'collection' || val.componentCode === 'marquee') {
        return;
      }
      val.boole = true;
      this.tableData.map(function (i, index) {
        if (itemIndex !== index) {
          i.boole = false;
        }
      });
    },
    bothMouseLeave: function bothMouseLeave() {
      this.tableData.map(function (i) {
        i.boole = false;
      });
    },
    bothClick: function bothClick(val) {
      this.moduleUpdate(val);
    },
    drageBuff: function drageBuff() {
      var _this4 = this;
      var tbody = document.querySelector('.my_table_name .el-table__body-wrapper tbody');
      _sortablejs.default.create(tbody, {
        handle: '.dg_div',
        animation: 150,
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
            oldIndex = _ref.oldIndex;
          console.log(newIndex, oldIndex);
          console.log(_this4.tableData[newIndex].sort, _this4.tableData[oldIndex].moduleId);
          (0, _customPage.updateSort)({
            moduleId: _this4.tableData[oldIndex].moduleId,
            targetSort: _this4.tableData[newIndex].sort
          }).then(function (res) {
            if (res.data) {
              _this4.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
            }
            _this4.$nextTick(function () {
              _this4.tableData = [];
              _this4.findModule();
            });
          });
        }
      });
    }
  }
};